const state = () => ({
  categories: [],
  filterCategories: [],
  sortingRelevance: true,
  sortingAsc: false,
  sortingDsc: false,
  selectedCategoryId: 0,
  loaded: false
})

const getters = {
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setCategories (state, payload) {
    state.categories = payload
  },
  setFilterCategories (state, payload) {
    state.filterCategories = payload
  },
  setSelectedCategoryId (state, payload) {
    state.selectedCategoryId = payload
  },
  addFilterCategory (state, payload) {
    state.filterCategories.push(payload)
  },
  removeFilterCategory (state, payload) {
    state.filterCategories.splice(state.filterCategories.indexOf(payload), 1)
  },
  clearFilterCategories (state) {
    state.filterCategories = []
  },
  setSortingRelevance (state, payload) {
    if (payload) {
      state.sortingRelevance = payload
      state.sortingAsc = false
      state.sortingDsc = false
    } else {
      state.sortingRelevance = false
      state.sortingAsc = true
      state.sortingDsc = false
    }
  },
  setSortingAsc (state, payload) {
    if (payload) {
      state.sortingAsc = payload
      state.sortingRelevance = false
      state.sortingDsc = false
    } else {
      state.sortingRelevance = true
      state.sortingAsc = false
      state.sortingDsc = false
    }
  },
  setSortingDsc (state, payload) {
    if (payload) {
      state.sortingDsc = payload
      state.sortingRelevance = false
      state.sortingAsc = false
    } else {
      state.sortingRelevance = true
      state.sortingAsc = false
      state.sortingDsc = false
    }
  },
  removeLevel1OfSelectedCategory (state) {
    if (state.selectedCategoryId > 0) {
      // only main categories can be selected in backend
      // eslint-disable-next-line prefer-const
      for (let level1 in state.categories) {
        // eslint-disable-next-line prefer-const
        for (let cat in state.categories[level1].options) {
          if (state.categories[level1].options[cat].categoryId === state.selectedCategoryId) {
            delete state.categories[level1]
            break
          }
        }
      }
    }
  }
}

const actions = {
  initFilter ({ commit }) {
    commit('setLoaded', false)
    commit('setCategories', JSON.parse(window.app.product_list.filters))
    commit('setSelectedCategoryId', parseInt(window.app.product_list.categoryId))
    commit('removeLevel1OfSelectedCategory')
    commit('setLoaded', true)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
